<fa-icon
  *ngIf="status"
  [icon]="circle"
  [size]="'xs'"
  [title]="statusTooltip"
  class="EmailStatus-{{ status }}"></fa-icon>
